import { ITableSettings } from '@components/Table/types';
import { TLocations } from '@pages/Locations/LocationsTable/types';

export const locationTableSettings: ITableSettings<TLocations>[] = [
  {
    accessor: 'name',
    title: 'Location name',
  },
  {
    accessor: 'number',
    title: 'Phone number',
  },
  {
    accessor: 'address',
    title: 'Address',
  },
];
